export default "__VITE_ASSET__fc6f5b1f__"